import { render, staticRenderFns } from "./emp.vue?vue&type=template&id=06bd4154&"
import script from "./emp.vue?vue&type=script&lang=js&"
export * from "./emp.vue?vue&type=script&lang=js&"
import style0 from "./emp.vue?vue&type=style&index=0&id=06bd4154&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports